import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowLeft = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M3.37307 7.25095L14.75 7.25095C14.9628 7.25095 15.141 7.32274 15.2846 7.46632C15.4282 7.60991 15.5 7.78811 15.5 8.00092C15.5 8.21374 15.4282 8.39194 15.2846 8.53552C15.141 8.67911 14.9628 8.7509 14.75 8.7509L3.37307 8.7509L8.54232 13.9201C8.69104 14.0689 8.76443 14.2429 8.7625 14.4422C8.76058 14.6416 8.68206 14.8189 8.52692 14.974C8.37181 15.1188 8.19618 15.1938 8.00003 15.199C7.80388 15.2041 7.62824 15.1291 7.47313 14.974L1.13275 8.6336C1.03917 8.54002 0.97314 8.4413 0.934674 8.33745C0.896207 8.23362 0.876973 8.12144 0.876973 8.00092C0.876973 7.88041 0.896207 7.76823 0.934674 7.6644C0.97314 7.56055 1.03917 7.46183 1.13275 7.36825L7.47312 1.02787C7.61157 0.889405 7.78304 0.818572 7.98752 0.815372C8.19201 0.812173 8.37181 0.883005 8.52692 1.02787C8.68206 1.18299 8.75962 1.36119 8.75962 1.56247C8.75962 1.76376 8.68206 1.94196 8.52692 2.09707L3.37307 7.25095Z",
		fill: "currentColor"
	})
});
export { SvgArrowLeft as ReactComponent };
